import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentLinkService } from "../../../../services/document/document-link.service";
import { notification } from "antd";

export const useCreateDocumentLink = () => {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation({
    mutationFn: (vars: any) => DocumentLinkService.createDocumentLinkInfo(vars),
  });

  const createDocumentLink = (
    body: any,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(body, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["document-link"],
        });
        queryClient.invalidateQueries({
          queryKey: ["document-linked"],
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Thêm thất bại.`,
        });
      },
    });
  };

  return { createDocumentLink, ...rest };
};
